import "./index.css";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import IconFont from "./IconFont";
import { AuthProvider } from "./contexts/AuthContext";

// PAGES
import Home from "./pages/Home";
import Balance from "./pages/Balance";
import Transactions from "./pages/Transactions";
import HowMuch from "./pages/HowMuch";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PrivateKey from "./pages/PrivateKey";
import Futures from "./pages/Futures";
import DeltaNeutral from "./pages/DeltaNeutral";
import Dashboard from "./pages/Dashboard";
import ILChecker from "./pages/ilChecker";
import TimeMachine from "./pages/TimeMachine";

//COMPONENTS
import EditToken from "./components/dashboard/EditToken";
import Footer from "./components/Footer";
import Header from "./components/Header";
import UnitPriceCalculator from "./components/UnitPriceCalculator";

function App() {
  return (
    <div className="flex flex-col min-h-screen App">
      <AuthProvider>
        <Router>
          <IconFont />
        <Header />
        <div className="max-w-[1300px] relative self-center w-11/12 md-w-full">
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route
            exact
            path="/unit-price-calculator"
            element={<UnitPriceCalculator />}
          />
          <Route exact path="/balance" element={<Balance />} />
          <Route exact path="/transactions" element={<Transactions />} />
          <Route exact path="/how-much-received" element={<HowMuch />} />
          <Route exact path="/private-key" element={<PrivateKey />} />
          <Route exact path="/futures" element={<Futures />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/editToken" element={<EditToken />} />
          <Route exact path="/delta-neutral" element={<DeltaNeutral />} />
          <Route exact path="/il-checker" element={<ILChecker />} />
          <Route exact path="/time-machine" element={<TimeMachine />} />
        </Routes>
        </div>
          <Footer />
        </Router>
      </AuthProvider>
    </div>
  );
}

export default App;
